import * as React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LOCAL_CONSTANT } from "../Const";
import { useUserContext } from "../../user-provider";
import { postPython, apiRequest } from "../../api/ApiCall";
import { useUtilityContext } from "../../utility-provider";
import { setLongPageParamObj } from "../../features/longPageSlice";
import MessageDialog from "../components/MessageDialog";
import { getLongPageData } from "../../data/DataManage";
import { locationBaseData, upsertLocationBaseFileParam } from "../components/LocationBaseFunc";
import { addSurveyData } from "../components/LocationAddSurveyFunc";
import { locationBaseTypeList, initLocationBaseObj } from "../../data/type";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { commonFileDownload, staffName, sortFilesByUploadDate, handleNewTabPage, shouldShowRequestCommentButton, compareBranchValues } from "../Common";
import { decryptQueryParam } from "../../utility/util";
import PdfViewerModal from "../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../utility/PdfViewerModal";
import { getFileMetadata, uploadFile, deleteUploadFile } from "../../utility/storage";
import PdfViewer from "../../utility/PdfViewer";
import { userLogging } from "../../utility/firestore";


import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Box,
    Button,
    TableContainer,
    Grid,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    styled,
    createTheme
} from "@mui/material";

export interface resultDialogProps {
    props: {
        width: number,
        height: number
    }
};

//スタイル
const FloatButton = styled(Button)({
    backgroundColor: "#FFFFFF",
    color: "#0E6F55",
    border: "solid 1px #00AC4C",
    marginLeft: "10px",
    "&: hover": {
        backgroundColor: "#F0F0F0",
        borderColor: "#00AC4C"
    },
});

const theme = createTheme({
    spacing: 4,
});

// カテゴリ列: 12%
const narrowSubHeaderCell = {
    backgroundColor: "#F8F8F8",
    width: "12%",
    borderBottom: "none"
};

// 文字がない場合のカテゴリ列 : 12%
const narrowSubHeaderBlankCell = (isLast: boolean) => ({
    backgroundColor: "#F8F8F8",
    width: "12%",
    borderBottom: isLast ? undefined : "none"
});

// ファイル名列: 33%
const fileNameCell = {
    backgroundColor: "#D9D9D9",
    fontSize: "12px",
    color: "black",
    borderBottom: "1px solid black",
    fontWeight: "Bold",
    width: "33%"
};

// アップロード日列: 15%
const uploadDateCell = {
    backgroundColor: "#D9D9D9",
    fontSize: "12px",
    color: "black",
    borderBottom: "1px solid black",
    fontWeight: "Bold",
    width: "15%"
};

// アップロード者列: 15%
const uploaderCell = {
    backgroundColor: "#D9D9D9",
    fontSize: "12px",
    color: "black",
    borderBottom: "1px solid black",
    fontWeight: "Bold",
    width: "15%"
};

// アイコン列: 8%
const iconCell = {
    backgroundColor: "#D9D9D9",
    fontSize: "12px",
    color: "black",
    borderBottom: "1px solid black",
    fontWeight: "Bold",
    width: "8%"
};

// サブヘッダー行のスタイル
const subHeaderRow = {
    backgroundColor: "#F8F8F8"
};

// サブヘッダーセルのスタイル
const subHeaderCell = {
    backgroundColor: "#F8F8F8",
    borderBottom: "none"
};


const PdfSummary: React.FC<resultDialogProps> = ({ props }) => {

    const dispatch = useAppDispatch();
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    const utilityCtx = useUtilityContext();
    const [userType, setUserType] = React.useState("");
    const [userId, setUserId] = React.useState<string>("");
    const user = useUserContext();
    const [message, setMessage] = React.useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] = React.useState<boolean>(false);
    const [hasButton, setHasButton] = React.useState<boolean>(false);
    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] = React.useState(false);
    const [path, setPath] = React.useState<string>("");
    // 調査書基本
    const [locationBase, setLocationBase] = React.useState<locationBaseTypeList>(initLocationBaseObj);
    // PDFリスト
    const [approvalList, setApprovalList] = React.useState<any>([]);
    const [requestPdfList, setRequestPdfList] = React.useState<any>([]);
    const [confirmList, setConfirmList] = React.useState<any>([]);
    const [additionalSurveyPdfList, setAdditionalSurveyPdfList] = React.useState<any>([]);
    const [trendsFileList, setTrendsFileList] = React.useState<any>([]);
    const [salesForecastList, setSalesForecastList] = React.useState<any>([]);
    const [otherDocumentRRList, setOtherDocumentRRList] = React.useState<any>([]);
    const [mapList, setMapList] = React.useState<any>([]);
    const [drawingList, setDrawingList] = React.useState<any>([]);
    // プレビュー用の状態管理
    const [previewPdfPathRequest, setPreviewPdfPathRequest] = React.useState<string>("");
    const [previewPdfPathApproval, setPreviewPdfPathApproval] = React.useState<string>("");
    const [previewPdfPathConfirm, setPreviewPdfPathConfirm] = React.useState<string>("");
    const [previewPdfPathUnified, setPreviewPdfPathUnified] = React.useState<string>("");
    // S店 調査書基本
    const [sStoreLocationBase, setSStoreLocationBase] = React.useState<locationBaseTypeList>(initLocationBaseObj);
    // S店 usePlanAreaId
    const [usePlanAreaId, setUsePlanAreaId] = React.useState<string>("");
    // S店 PDFリスト
    const [sStoreRequestPdfList, setSStoreRequestPdfList] = React.useState<any>([]);
    const [sStoreConfirmList, setSStoreConfirmList] = React.useState<any>([]);
    const [sStoreTrendsFileList, setSStoreTrendsFileList] = React.useState<any>([]);
    const [sStoreSalesForecastList, setSStoreSalesForecastList] = React.useState<any>([]);
    const [sStoreOtherDocumentRRList, setSStoreOtherDocumentRRList] = React.useState<any>([]);
    const [sStoreMapList, setSStoreMapList] = React.useState<any>([]);
    const [sStoreDrawingList, setSStoreDrawingList] = React.useState<any>([]);
    // S店 プレビュー状態管理
    const [previewPdfPathSStoreRequest, setPreviewPdfPathSStoreRequest] = React.useState<string>("");
    const [previewPdfPathSStoreConfirm, setPreviewPdfPathSStoreConfirm] = React.useState<string>("");
    const [previewPdfPathSStoreUnified, setPreviewPdfPathSStoreUnified] = React.useState<string>("");
    // 枝リスト
    type BranchItem = {value: string; label: string};
    const [branchList, setBranchList] = React.useState<BranchItem[]>([]);
    const [branchLoading, setBranchLoading] = React.useState<boolean>(false);
    // 依頼/コメントに遷移するときに、最新の枝を指定
    const [maxBranch, setMaxBranch] = React.useState<string>("");

    //UPLパラメーターから候補地NOと枝番保存
    React.useEffect(() => {
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            dispatch(
                setLongPageParamObj({
                    ...objLongPageParam,
                    planAreaId: res[0],
                    branch: res[1]
                })
            );
        }).catch((e:any) => {
            console.log(e);
        });
    }, []);

    React.useEffect(() => {
        if (objLongPageParam.planAreaId && objLongPageParam.branch) {
            getPDFList();
        }
    }, [objLongPageParam])

    //ユーザー取得
    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
            setUserId(JSON.parse(user.userData || "null").staff_number);
        }
    }, [user]);

    // planAreaIdからbranch一覧を取得
    const getBranches = async (planAreaId: string) => {
        const params = {
            mode: "regist",
            endPoint: "/location/Reception/v1/branches",
            query: {
                plan_area_id: planAreaId
            }
        };
        
        try {
            const response = await apiRequest(params);
            return response;
        } catch (error) {
            console.error("Branch取得エラー:", error);
            throw error;
        }
    };

    // planAreaIdが変更された時にbranch一覧を取得
    React.useEffect(() => {
        if (objLongPageParam.planAreaId) {
            setBranchLoading(true);
            getBranches(objLongPageParam.planAreaId)
                .then((response) => {
                    if (response.data.dataList.length > 0) {
                        
                        // APIレスポンスを取得
                        const branchesData = JSON.parse(response.data.dataList[0]);
                        const branches = branchesData.branches;
                        
                        // 枝番プルダウン用フォーマット（ソート済み）
                        const sortedBranches = branches.sort((a: string, b: string) => 
                            compareBranchValues(a, b)
                        );
                        
                        // ソート済み配列から最大枝番を取得（最後の要素）
                        if (sortedBranches.length > 0) {
                            setMaxBranch(sortedBranches[sortedBranches.length - 1]);
                        }
                        
                        const formattedBranches: BranchItem[] = sortedBranches.map((branch: string) => ({
                            value: branch,
                            label: `${branch}`
                        }));
                        setBranchList(formattedBranches);
                    } else {
                        setBranchList([]);
                        setMaxBranch("");
                    }
                })
                .catch((error) => {
                    console.error("Branch取得失敗:", error);
                    setBranchList([]);
                })
                .finally(() => {
                    setBranchLoading(false);
                });
        }
    }, [objLongPageParam.planAreaId]);

    // 表示するデータをGraphQLで取得
    const getPDFList = async () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        
        try {
            const param = [
                {
                    mode: "getLocationBase",
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch
                },
                {
                    mode: "getLocationAddSurvey",
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch
                },
                {
                    mode: "getLocationSalesForecast",
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch
                },
                {
                    mode: "getLocationDrawing",
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch
                }
            ];
            
            const response: any = await getLongPageData(param);
            
            if (response?.getLocationBase && response.getLocationBase.length > 0) {
                const locationData = locationBaseData(response.getLocationBase);
                // 調査書基本を保存
                setLocationBase(locationData);
                
                // 共通化関数を使用してデータ処理
                const processedData = processLocationBaseData(locationData);
                // 稟申用PDFデータ
                setApprovalList(processedData.approvalList);
                // 依頼時調査書PDFデータ
                setRequestPdfList(processedData.requestPdfList);
                // RR確認用調査書PDFデータ
                setConfirmList(processedData.confirmList);
                // 5年間推移表PDFデータ              
                setTrendsFileList(processedData.trendsFileList);
                // その他資料RR PDFデータ（フィルタリング + upload_dateで昇順ソート）
                setOtherDocumentRRList(processedData.otherDocumentRRList);
                
                // 地図PDFデータ
                if (processedData.extractedMapFiles.length > 0) {
                    const mapWithMetadata = await getPdfDataWithMetadata(processedData.extractedMapFiles, "地図PDF");
                    setMapList(mapWithMetadata);
                }
            }

            // 追加調査一式PDFデータ
            if (response?.getLocationAddSurvey && response.getLocationAddSurvey.length > 0) {
                const locationAddSurveyData = addSurveyData(response.getLocationAddSurvey);
                if (locationAddSurveyData.merge_file_path && locationAddSurveyData.merge_file_path.length > 0) {
                    // upload_dateで降順ソート
                    const sortedMergeFiles = locationAddSurveyData.merge_file_path.sort((a: any, b: any) => 
                        new Date(b.upload_date).getTime() - new Date(a.upload_date).getTime()
                    );
                    // 全ファイルを取得
                    setAdditionalSurveyPdfList(sortedMergeFiles);
                }
            }

            // 予測集計表PDFデータ
            if (response?.getLocationSalesForecast && response.getLocationSalesForecast.length > 0) {
                const extractedSalesForecastFiles = extractSalesForecastFiles(response.getLocationSalesForecast);
                if (extractedSalesForecastFiles.length > 0) {
                    const salesForecastWithMetadata = await getPdfDataWithMetadata(extractedSalesForecastFiles, "予測集計表PDF");
                    setSalesForecastList(salesForecastWithMetadata);
                }
            }
            
            // 図面PDFデータ
            if (response?.getLocationDrawing && response.getLocationDrawing.length > 0) {
                const extractedDrawingFiles = extractDrawingFiles(response.getLocationDrawing[0]);
                if (extractedDrawingFiles.length > 0) {
                    const drawingWithMetadata = await getPdfDataWithMetadata(extractedDrawingFiles, "図面PDF");
                    setDrawingList(drawingWithMetadata);
                }
            }

            // S店のデータを取得（planAreaIdがXかYで始まる場合は実行しない）
            if (!objLongPageParam.planAreaId?.startsWith("X") && !objLongPageParam.planAreaId?.startsWith("Y")) {
                if (response?.getLocationBase && response.getLocationBase.length > 0) {
                    const locationData = locationBaseData(response.getLocationBase);
                    if (locationData && locationData.child_location) {
                        const existingSejParam = [
                            {
                                mode: "getExistingSejStoreUsePlanAreaId",
                                plan_area_id: objLongPageParam.planAreaId,
                                branch: objLongPageParam.branch,
                                child_location: locationData.child_location
                            }
                        ];
                        
                        const existingSejResponse: any = await getLongPageData(existingSejParam);
                        if (existingSejResponse?.getExistingSejStoreUsePlanAreaId) {
                            const usePlanAreaIdValue = existingSejResponse.getExistingSejStoreUsePlanAreaId[0].use_plan_area_id;
                            // S店のusePlanAreaIdを保存
                            setUsePlanAreaId(usePlanAreaIdValue);
                            
                            // use_plan_area_idを使ってS店データを取得
                            const sStroreParam = [
                                {
                                    mode: "getLocationBase",
                                    plan_area_id: usePlanAreaIdValue,
                                    branch: objLongPageParam.branch
                                },
                                {
                                    mode: "getLocationAddSurvey",
                                    plan_area_id: usePlanAreaIdValue,
                                    branch: objLongPageParam.branch
                                },
                                {
                                    mode: "getLocationSalesForecast",
                                    plan_area_id: usePlanAreaIdValue,
                                    branch: objLongPageParam.branch
                                },
                                {
                                    mode: "getLocationDrawing",
                                    plan_area_id: usePlanAreaIdValue,
                                    branch: objLongPageParam.branch
                                }
                            ];
                            
                            const sStoreResponse: any = await getLongPageData(sStroreParam);
                            
                            // S店 getLocationBaseデータを処理
                            if (sStoreResponse?.getLocationBase && sStoreResponse.getLocationBase.length > 0) {
                                const sStoreLocationData = locationBaseData(sStoreResponse.getLocationBase);
                                // S店 調査書基本を保存
                                setSStoreLocationBase(sStoreLocationData);
                                
                                // 共通化関数を使用して、S店データ処理
                                const sStoreProcessedData = processLocationBaseData(sStoreLocationData);
                                // S店 依頼時調査書PDFデータ
                                setSStoreRequestPdfList(sStoreProcessedData.requestPdfList);
                                // S店 RR確認用調査書PDFデータ
                                setSStoreConfirmList(sStoreProcessedData.confirmList);
                                // S店 5年間推移表PDFデータ              
                                setSStoreTrendsFileList(sStoreProcessedData.trendsFileList);
                                // S店 その他資料RR PDFデータ（フィルタリング + upload_dateで昇順ソート）
                                setSStoreOtherDocumentRRList(sStoreProcessedData.otherDocumentRRList);
                                
                                // S店 地図PDFデータ
                                if (sStoreProcessedData.extractedMapFiles.length > 0) {
                                    const sStoreMapWithMetadata = await getPdfDataWithMetadata(sStoreProcessedData.extractedMapFiles, "S店地図PDF", usePlanAreaIdValue);
                                    setSStoreMapList(sStoreMapWithMetadata);
                                }
                            }


                            // S店 予測集計表PDFデータ
                            if (sStoreResponse?.getLocationSalesForecast && sStoreResponse.getLocationSalesForecast.length > 0) {
                                const sStoreExtractedSalesForecastFiles = extractSalesForecastFiles(sStoreResponse.getLocationSalesForecast);
                                if (sStoreExtractedSalesForecastFiles.length > 0) {
                                    const sStoreSalesForecastWithMetadata = await getPdfDataWithMetadata(sStoreExtractedSalesForecastFiles, "S店予測集計表PDF", usePlanAreaIdValue);
                                    setSStoreSalesForecastList(sStoreSalesForecastWithMetadata);
                                }
                            }
                            
                            // S店 図面PDFデータ
                            if (sStoreResponse?.getLocationDrawing && sStoreResponse.getLocationDrawing.length > 0) {
                                const sStoreExtractedDrawingFiles = extractDrawingFiles(sStoreResponse.getLocationDrawing[0]);
                                if (sStoreExtractedDrawingFiles.length > 0) {
                                    const sStoreDrawingWithMetadata = await getPdfDataWithMetadata(sStoreExtractedDrawingFiles, "S店図面PDF", usePlanAreaIdValue);
                                    setSStoreDrawingList(sStoreDrawingWithMetadata);
                                }
                            }
                        }
                    }
                }
            }
        } catch (e: any) {
            console.error('データ取得エラー:', e);
        } finally {
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }
    }


    const create_pdf = (endPoint: string, isForSStore: boolean = false) => {
        // リサーチ
        let call_user_type = "1"

        // S店の場合はusePlanAreaIdを使用
        const planAreaIdToUse = isForSStore ? usePlanAreaId : objLongPageParam.planAreaId;

        const params = {
            mode: "regist",
            endPoint: endPoint,
            query: {
                prop_site_no: planAreaIdToUse,
                branch: objLongPageParam.branch,
                call_user_type: call_user_type,
                upload_user_id: userId
            }
        };

        // userLogging
        let functionName = "";
        if (endPoint === "/create-location-approval-pdf") {
            functionName = LOCAL_CONSTANT.FUNCTION_NAME.APPROVAL_PDF_CREATE;
        } else {
            functionName = LOCAL_CONSTANT.FUNCTION_NAME.CONFIRM_PDF_CREATE;
        }
        userLogging(functionName, params, user);

        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CREATE_PDF)
                setMessageDialogOpen(true)
                await postPython(params)
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.COMPLETE_CREATE_PDF)
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UNCOMPLETE_CREATE_PDF)
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }

    const closeMessageDialog = () => {
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
        getPDFList();
    };

    // 稟申用PDFアップロード処理
    const handleApprovalPdfUpload = (isForSStore: boolean = false) => {
        const fileElem = isForSStore 
            ? document.getElementById("sStoreApprovalPdfFileElem")
            : document.getElementById("approvalPdfFileElem");
        if (fileElem) {
            fileElem.click();
        }
    };

    // ファイル選択時の処理
    const handleChangeApprovalFile = (newFile: any) => {
        if (newFile.target.files[0]) {
            fileUploadApproval(newFile.target.files[0]);
        }
        newFile.target.value = "";
    };

    // 稟申用PDFファイルアップロード処理
    const fileUploadApproval = (file: any) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD_FILE);
                setMessageDialogOpen(true);

                // 既存ファイル削除処理（稟申用PDFは1つのみ保存可能）
                if (approvalList && approvalList.length > 0) {
                    for (let i = 0; i < approvalList.length; i++) {
                        const existingFile = approvalList[i];
                        try {
                            const existingFilePath = `${objLongPageParam.planAreaId}/${objLongPageParam.branch}${existingFile.file_path}`;
                            const deleteFileMetadata = await getFileMetadata(existingFilePath);
                            await deleteUploadFile(deleteFileMetadata, existingFilePath);
                        } catch (deleteError) {
                            console.log("既存ファイル削除エラー:", deleteError);
                        }
                    }
                }

                // ファイルアップロード
                const bucketPath = `${objLongPageParam.planAreaId}/${objLongPageParam.branch}/pdf/approval_pdf/`;
                const uploadFileName = file.name;
                await uploadFile(file, `${bucketPath}${uploadFileName}`);
                const uploadResultFile = await getFileMetadata(`${bucketPath}${uploadFileName}`);

                // アップロードファイル情報作成
                const uploadFileInfo = {
                    file_name: uploadFileName,
                    file_path: `/pdf/approval_pdf/${uploadFileName}`,
                    upload_date: dayjs(uploadResultFile?.timeCreated).format("YYYY/MM/DD HH:mm:ss"),
                    upload_user_id: userId
                };

                // 新しいapproval_pdf_pathリストを作成（既存を削除して新しいファイルを追加）
                const newApprovalPdfPath = [uploadFileInfo];

                // upsertLocationBaseFileParamを使用してDB更新
                const params = upsertLocationBaseFileParam(
                    locationBase,
                    objLongPageParam.planAreaId,
                    objLongPageParam.branch,
                    newApprovalPdfPath,
                    "approval_pdf_path",
                    uploadFileName
                );

                // userLogging
                userLogging(LOCAL_CONSTANT.FUNCTION_NAME.APPROVAL_PDF_UPLOAD, params, user);
                // DB保存
                await apiRequest(params);

                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_UPLOAD_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_UPLOAD_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };


    const handleBranchChange = (event: any) => {
        dispatch(
            setLongPageParamObj({
                ...objLongPageParam,
                branch: event.target.value
            })
        );
    };

    // 調査書基本のデータ処理を共通化 locationBaseDataから各種PDFリストを抽出・加工する処理
    const processLocationBaseData = (locationData: any) => {
        // その他資料RR PDFデータ（フィルタリング + upload_dateで昇順ソート）
        const filteredOtherDocumentRR = locationData.other_document_rr_path?.filter((item: any) => 
            item.other_rr_type === "99_other" && item.merge_order === ""
        ) || [];

        return {
            approvalList: locationData.approval_pdf_path,
            requestPdfList: locationData.request_pdf_path,
            confirmList: locationData.confirm_pdf_path,
            trendsFileList: locationData.trends_file_path,
            otherDocumentRRList: sortFilesByUploadDate(filteredOtherDocumentRR),
            extractedMapFiles: extractMapFiles(locationData)
        };
    };

    // 予測集計表PDFファイルを抽出する関数
    const extractSalesForecastFiles = (salesForecastData: any[]) => {
        const salesForecastItems: any[] = [];
        
        if (salesForecastData && salesForecastData.length > 0) {
            // temp_flag が "0"（通常出力） または "1"（仮出力） のファイルをフィルタリング
            const filteredItems = salesForecastData.filter((item: any) => 
                (item.temp_flag === "0" || item.temp_flag === "1") && 
                item.sales_forecast_pdf_path && 
                item.sales_forecast_pdf_path !== ""
            );
            
            // temp_flagを数値として昇順ソート（0（通常出力）→1（仮出力）の優先順位）
            filteredItems.sort((a: any, b: any) => {
                return parseInt(a.temp_flag) - parseInt(b.temp_flag);
            });
            
            // 最優先の1件のみを取得
            if (filteredItems.length > 0) {
                const topItem = filteredItems[0];
                salesForecastItems.push({
                    file_name: "予測集計表",
                    file_path: topItem.sales_forecast_pdf_path,
                    upload_date: "",
                    upload_user_id: topItem.sales_forecast_upload_user,
                    upload_user_name: ""
                });
            }
        }
        
        return salesForecastItems;
    };

    // 地図PDFファイルを抽出する関数
    const extractMapFiles = (locationData: any) => {
        const mapItems = [];
        
        // 地図
        if (locationData.map_pdf_path && locationData.map_pdf_path !== "") {
            mapItems.push({
                file_name: "地図",
                file_path: locationData.map_pdf_path,
                upload_user_id: locationData.map_pdf_user,
                upload_date: "",
            });
        }
        
        return mapItems;
    };

    // 図面PDFファイルを抽出する関数
    const extractDrawingFiles = (drawingData: any) => {
        const drawingItems = [];
        
        // レイアウト図
        if (drawingData.layout_file_path && drawingData.layout_file_path !== "") {
            drawingItems.push({
                file_name: "レイアウト図",
                file_path: drawingData.layout_file_path,
                upload_user_id: drawingData.layout_file_user,
                upload_date: ""
            });
        }
        
        // 配置図
        if (drawingData.placement_file_path && drawingData.placement_file_path !== "") {
            drawingItems.push({
                file_name: "配置図",
                file_path: drawingData.placement_file_path,
                upload_user_id: drawingData.placement_file_user,
                upload_date: ""
            });
        }
        
        // 設計事務所配置図
        if (drawingData.designer_placement_file_path && drawingData.designer_placement_file_path !== "") {
            drawingItems.push({
                file_name: "設計事務所配置図",
                file_path: drawingData.designer_placement_file_path,
                upload_user_id: drawingData.designer_placement_file_user,
                upload_date: ""
            });
        }
        
        return drawingItems;
    };

    // 共通PDFメタデータ取得関数
    const getPdfDataWithMetadata = async (items: any[], dataType: string, planAreaId: string = objLongPageParam.planAreaId) => {
        const filesWithMetadata = await Promise.all(
            items.map(async (item) => {
                try {
                    const filePath = `/${planAreaId}/${objLongPageParam.branch}${item.file_path}`;
                    const meta: any = await getFileMetadata(filePath);
                    return {
                        ...item,
                        file_name: meta.name,
                        upload_date: dayjs(meta.updated).format("YYYY/MM/DD HH:mm:ss")
                    };
                } catch (error) {
                    console.error(`${dataType}データ取得エラー:`, error);
                    return item;
                }
            })
        );
        
        return filesWithMetadata;
    };

    // プレビュー制御関数
    const handlePreviewChange = (pdfPath: string, section: string) => {
        // S店かどうかでplanAreaIdを選択
        const planAreaIdToUse = section.startsWith("s-store-") ? usePlanAreaId : objLongPageParam.planAreaId;
        const path = `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${planAreaIdToUse}/${objLongPageParam.branch}${pdfPath}`;
        
        if (section === "request") {
            // 依頼時調査書は個別プレビュー
            if (previewPdfPathRequest === path) {
                setPreviewPdfPathRequest("");
            } else {
                setPreviewPdfPathRequest(path);
            }
        } else if (section === "approval") {
            // 稟申用PDFは個別プレビュー
            if (previewPdfPathApproval === path) {
                setPreviewPdfPathApproval("");
            } else {
                setPreviewPdfPathApproval(path);
            }
        } else if (section === "confirm") {
            // RR確認用調査書は個別プレビュー
            if (previewPdfPathConfirm === path) {
                setPreviewPdfPathConfirm("");
            } else {
                setPreviewPdfPathConfirm(path);
            }
        } else if (section === "s-store-request") {
            // S店 依頼時調査書は個別プレビュー
            if (previewPdfPathSStoreRequest === path) {
                setPreviewPdfPathSStoreRequest("");
            } else {
                setPreviewPdfPathSStoreRequest(path);
            }
        } else if (section === "s-store-confirm") {
            // S店 RR確認用調査書は個別プレビュー
            if (previewPdfPathSStoreConfirm === path) {
                setPreviewPdfPathSStoreConfirm("");
            } else {
                setPreviewPdfPathSStoreConfirm(path);
            }
        } else if (section.startsWith("s-store-")) {
            // S店 任意確認資料は統一プレビュー
            if (previewPdfPathSStoreUnified === path) {
                setPreviewPdfPathSStoreUnified("");
            } else {
                setPreviewPdfPathSStoreUnified(path);
            }
        } else {
            // 任意確認資料は統一プレビュー
            if (previewPdfPathUnified === path) {
                setPreviewPdfPathUnified("");
            } else {
                setPreviewPdfPathUnified(path);
            }
        }
    };

    // PDFプレビューモーダルオープン
    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        setPath(pdfPathParam);
    };

    //ファイル保存
    const fileDownload = (data: any, isForSStore: boolean = false) => {
        const planAreaIdToUse = isForSStore ? usePlanAreaId : objLongPageParam.planAreaId;
        // 追加調査一式PDFの場合はpdf_pathフィールドを使用、それ以外のPDFはfile_pathフィールドを使用
        // 追加調査一式PDFのデータ構造が他のPDF（稟申用PDF、依頼時調査書等）と異なるため、この分岐が必要
        const pathToUse = data.pdf_path ? data.pdf_path : data.file_path;
        const filePath = `/${planAreaIdToUse}/${objLongPageParam.branch}${pathToUse}`;
        commonFileDownload(filePath, data.file_name);
    };

    return (
        <Box>
            <MessageDialog props={{
                open: messageDialogOpen,
                handleModal: closeMessageDialog,
                body: message,
                hasButton: hasButton,
                buttonBody: LOCAL_CONSTANT.LABEL.CLOSE
            }}
            />
            {/* フロートボタン */}
            <Grid container spacing={2}>
                <Grid item xs={5}></Grid>
                <Grid item xs={7} sx={{ position: "fixed", top: "7%", right: "2%", margin: theme.spacing(2), zIndex: 1000 }}>
                    {/* 子調査またはRFCの場合 依頼コメントボタンを非表示 */}
                    {shouldShowRequestCommentButton(userType, objLongPageParam.planAreaId) && 
                        <FloatButton variant="outlined" onClick={() => { handleNewTabPage("/RequestComment", objLongPageParam.planAreaId, maxBranch, utilityCtx) }}>依頼/コメント</FloatButton>
                    }
                </Grid>
            </Grid>
            {/** PDF確認 **/}
            <Grid container>
                <Grid item xs={12} sx={{ height: "48px" }} />
            </Grid>
            <Grid container direction={"row"}>
                <Grid item sx={{ width: "55px", height: props.height }} />
                <Grid item sx={{ width: props.width, height: props.height, overflowY: "scroll" }}>

                    <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                        <Grid item xs={12}>
                            <Typography component="h1" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em" }}>
                                {LOCAL_CONSTANT.LABEL.PDF_CONFIRM}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", gap: 2, alignItems: "center", margin: "10px 0" }}>
                                <FormControl sx={{ minWidth: 100 }}>
                                    <InputLabel id="branch-select-label">枝</InputLabel>
                                    <Select
                                        labelId="branch-select-label"
                                        id="branch-select"
                                        label="枝"
                                        value={objLongPageParam.branch}
                                        onChange={handleBranchChange}
                                        disabled={branchLoading}
                                        sx={{ "& .MuiSelect-select": { textAlign: "center" } }}
                                    >
                                        {branchList.map((branch: BranchItem) => (
                                            <MenuItem key={branch.value} value={branch.value}>
                                                {branch.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* リサーチのみ表示 */}
                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                    <>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            size="small"
                                            onClick={() => create_pdf("/create-location-pdf")}
                                        >
                                            PDF作成
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            size="small"
                                            onClick={() => create_pdf("/create-location-approval-pdf")}
                                        >
                                            稟申用PDF作成
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            size="small"
                                            onClick={() => handleApprovalPdfUpload()}
                                        >
                                            稟申用PDFアップロード
                                        </Button>
                                    </>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                    
                    {/* 稟申用PDFアップロード用ファイル入力要素 */}
                    <input
                        id="approvalPdfFileElem"
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleChangeApprovalFile}
                        accept=".pdf"
                    />

                    {/* 稟申用PDF セクション */}
                    <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                        <Grid item xs={12}>
                            <Typography component="h2" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em", marginBottom: "0" }}>
                                稟申用PDF
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                            <TableContainer sx={{ height: "130px", width: "100%", border: "1px solid black" }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={fileNameCell}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={uploadDateCell}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={uploaderCell}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={iconCell}></TableCell>
                                            <TableCell sx={iconCell}></TableCell>
                                            <TableCell sx={iconCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {approvalList && approvalList.length > 0 && 
                                            approvalList.map((row: any) => (
                                                <TableRow key={row.file_path}>
                                                    <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "approval")}>{row.file_name}</TableCell>
                                                    <TableCell onClick={() => handlePreviewChange(row.file_path, "approval")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                    <TableCell onClick={() => handlePreviewChange(row.file_path, "approval")}>{staffName(row.upload_user_id)}</TableCell>
                                                    <TableCell align="center">
                                                        <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                            <PictureAsPdfIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                            <OpenInNewIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row)}>
                                                            <DownloadIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>

                    {/* 稟申用PDFプレビュー */}
                    {previewPdfPathApproval !== "" && (
                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                            <PdfViewer props={{ pdfPath: previewPdfPathApproval }} />
                        </Box>
                    )}

                    {/* 依頼時調査書 セクション */}
                    <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                        <Grid item xs={12}>
                            <Typography component="h2" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em", marginBottom: "0" }}>
                                依頼時調査書
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                            <TableContainer sx={{ height: "130px", width: "100%", border: "1px solid black" }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={fileNameCell}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={uploadDateCell}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={uploaderCell}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={iconCell}></TableCell>
                                            <TableCell sx={iconCell}></TableCell>
                                            <TableCell sx={iconCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {requestPdfList && requestPdfList.length > 0 && 
                                            requestPdfList.map((row: any) => (
                                                <TableRow key={row.file_path}>
                                                    <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "request")}>{row.file_name}</TableCell>
                                                    <TableCell onClick={() => handlePreviewChange(row.file_path, "request")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                    <TableCell onClick={() => handlePreviewChange(row.file_path, "request")}>{staffName(row.upload_user_id)}</TableCell>
                                                    <TableCell align="center">
                                                        <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                            <PictureAsPdfIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                            <OpenInNewIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row)}>
                                                            <DownloadIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>

                    {/* 依頼時調査書プレビュー */}
                    {previewPdfPathRequest !== "" && (
                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                            <PdfViewer props={{ pdfPath: previewPdfPathRequest }} />
                        </Box>
                    )}

                    {/* RR確認用調査書 セクション リサーチのみ表示 */}
                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                        <>
                            <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                                <Grid item xs={12}>
                                    <Typography component="h2" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em", marginBottom: "0" }}>
                                        RR確認用調査書
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                                    <TableContainer sx={{ 
                                        height: `${Math.max((confirmList?.length || 0) + (additionalSurveyPdfList?.length || 0), 1) * 73 + 57}px`,
                                        width: "100%", 
                                        border: "1px solid black" 
                                    }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={fileNameCell}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                                    <TableCell sx={uploadDateCell}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                                    <TableCell sx={uploaderCell}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* RR確認用調査書 立地調査書一式 */}
                                                {confirmList && confirmList.length > 0 && 
                                                    confirmList.map((row: any) => (
                                                        <TableRow key={row.file_path}>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "confirm")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "confirm")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "confirm")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* RR確認用調査書 追加調査一式 */}
                                                {additionalSurveyPdfList && additionalSurveyPdfList.length > 0 && 
                                                    additionalSurveyPdfList.map((row: any, index: number) => {
                                                        // 最新ファイルは通常表示、それ以外はグレーアウト
                                                        const isLatest = index === 0;
                                                        const displayLabel = row.file_name.replace('.pdf', '');
                                                        return (
                                                            <TableRow 
                                                                key={row.pdf_path}
                                                                sx={{ backgroundColor: isLatest ? "#fff" : "#D9D9D9" }}
                                                            >
                                                                <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.pdf_path, "confirm")}>
                                                                    {displayLabel}
                                                                </TableCell>
                                                                <TableCell onClick={() => handlePreviewChange(row.pdf_path, "confirm")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                                <TableCell onClick={() => handlePreviewChange(row.pdf_path, "confirm")}>{staffName(row.upload_user_id)}</TableCell>
                                                                <TableCell align="center">
                                                                    <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`)}>
                                                                        <PictureAsPdfIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`)}>
                                                                        <OpenInNewIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row)}>
                                                                        <DownloadIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>

                            {/* RR確認用調査書プレビュー */}
                            {previewPdfPathConfirm !== "" && (
                                <Box sx={{ padding: "30px 40px 0px 0px" }}>
                                    <PdfViewer props={{ pdfPath: previewPdfPathConfirm }} />
                                </Box>
                            )}
                        </>
                    )}

                    {/* 任意確認資料 セクション リサーチのみ表示 */}
                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                        <>
                            <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                                <Grid item xs={12}>
                                    <Typography component="h2" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em", marginBottom: "0" }}>
                                        任意確認資料
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                                    <TableContainer sx={{ width: "100%", border: "1px solid black" }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={iconCell}></TableCell>
                                                    <TableCell sx={fileNameCell}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                                    <TableCell sx={uploadDateCell}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                                    <TableCell sx={uploaderCell}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>予測集計表</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {/* 5年間推移表 */}
                                                {trendsFileList && trendsFileList.length > 0 && 
                                                    trendsFileList.map((row: any, index: number) => (
                                                        <TableRow key={`trends-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === trendsFileList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.pdf_path, "trends")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.pdf_path, "trends")}>{row.upload_date}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.pdf_path, "trends")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton
                                                                    sx={{ color: "black" }} 
                                                                    onClick={() => {
                                                                        // row.pdf_pathから拡張子を抽出
                                                                        const extension = "." + row.pdf_path.split(".").pop();
                                                                        commonFileDownload(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`, `${row.file_name}${extension}`);
                                                                    }}
                                                                >
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* 予測集計表 */}
                                                {salesForecastList && salesForecastList.length > 0 && 
                                                    salesForecastList.map((row: any, index: number) => (
                                                        <TableRow key={`sales-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === salesForecastList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "sales")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "sales")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "sales")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* その他資料RR */}
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>その他資料RR</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {otherDocumentRRList && otherDocumentRRList.length > 0 && 
                                                    otherDocumentRRList.map((row: any, index: number) => (
                                                        <TableRow key={`other-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === otherDocumentRRList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.path, "other")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.path, "other")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.path, "other")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton
                                                                    sx={{ color: "black" }}
                                                                    onClick={() => {
                                                                        // row.pathから拡張子を抽出
                                                                        const extension = "." + row.path.split(".").pop();
                                                                        commonFileDownload(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.path}`, `${row.file_name}${extension}`);
                                                                    }}
                                                                >
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* 地図 */}
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>地図</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {mapList && mapList.length > 0 && 
                                                    mapList.map((row: any, index: number) => (
                                                        <TableRow key={`map-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === mapList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "map")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "map")}>{row.upload_date}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "map")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* 図面 */}
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>図面</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {drawingList && drawingList.length > 0 && 
                                                    drawingList.map((row: any, index: number) => (
                                                        <TableRow key={`drawing-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === drawingList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "drawing")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "drawing")}>{row.upload_date}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "drawing")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>

                            {/* 任意確認資料統一プレビュー */}
                            {previewPdfPathUnified !== "" && (
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                                            <PdfViewer props={{ pdfPath: previewPdfPathUnified }} />
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}
                        </>
                    )}

                    {/* S店 セクション */}
                    {!objLongPageParam.planAreaId?.startsWith("X") && 
                    !objLongPageParam.planAreaId?.startsWith("Y") && (
                        <>
                            <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                                <Grid item xs={12}>
                                    <Typography component="h1" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "2em" }}>
                                        S店 PDF
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box sx={{ display: "flex", gap: 2, alignItems: "center", margin: "10px 0" }}>
                                        {userType === LOCAL_CONSTANT.USER_TYPE.RR && usePlanAreaId && (
                                            <>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="small"
                                                    onClick={() => create_pdf("/create-location-pdf", true)}
                                                >
                                                    S店　PDF
                                                </Button>
                                            </>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>


                            {/* S店 依頼時調査書 セクション */}
                            <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                                <Grid item xs={12}>
                                    <Typography component="h2" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em", marginBottom: "0" }}>
                                        依頼時調査書
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                                    <TableContainer sx={{ height: "130px", width: "100%", border: "1px solid black" }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={fileNameCell}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                                    <TableCell sx={uploadDateCell}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                                    <TableCell sx={uploaderCell}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                    <TableCell sx={iconCell}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {sStoreRequestPdfList && sStoreRequestPdfList.length > 0 && 
                                                    sStoreRequestPdfList.map((row: any) => (
                                                        <TableRow key={row.file_path}>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "s-store-request")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-request")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-request")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row, true)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>

                            {/* S店 依頼時調査書プレビュー */}
                            {previewPdfPathSStoreRequest !== "" && (
                                <Box sx={{ padding: "30px 40px 0px 0px" }}>
                                    <PdfViewer props={{ pdfPath: previewPdfPathSStoreRequest }} />
                                </Box>
                            )}

                            {/* S店 RR確認用調査書 セクション */}
                            {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                <>
                                    <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                                        <Grid item xs={12}>
                                            <Typography component="h2" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em", marginBottom: "0" }}>
                                                RR確認用調査書
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                                            <TableContainer sx={{ 
                                                height: `${Math.max((sStoreConfirmList?.length || 0), 1) * 73 + 57}px`,
                                                width: "100%", 
                                                border: "1px solid black" 
                                            }}>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={fileNameCell}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                                            <TableCell sx={uploadDateCell}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                                            <TableCell sx={uploaderCell}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                                            <TableCell sx={iconCell}></TableCell>
                                                            <TableCell sx={iconCell}></TableCell>
                                                            <TableCell sx={iconCell}></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {/* S店 RR確認用調査書 立地調査書一式 */}
                                                        {sStoreConfirmList && sStoreConfirmList.length > 0 && 
                                                            sStoreConfirmList.map((row: any) => (
                                                                <TableRow key={row.file_path}>
                                                                    <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "s-store-confirm")}>{row.file_name}</TableCell>
                                                                    <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-confirm")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                                    <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-confirm")}>{staffName(row.upload_user_id)}</TableCell>
                                                                    <TableCell align="center">
                                                                        <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                            <PictureAsPdfIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                            <OpenInNewIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row, true)}>
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>

                                    {/* S店 RR確認用調査書プレビュー */}
                                    {previewPdfPathSStoreConfirm !== "" && (
                                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                                            <PdfViewer props={{ pdfPath: previewPdfPathSStoreConfirm }} />
                                        </Box>
                                    )}
                                </>
                            )}

                            {/* S店 任意確認資料 セクション */}
                            {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                <>
                                    <Grid container spacing={1} sx={{ paddingLeft: "20px" }}>
                                        <Grid item xs={12}>
                                            <Typography component="h2" sx={{ fontSize: "1.17em", fontWeight: "bold", marginTop: "1em", marginBottom: "0" }}>
                                                任意確認資料
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                                            <TableContainer sx={{ width: "100%", border: "1px solid black" }}>
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={iconCell}></TableCell>
                                                            <TableCell sx={fileNameCell}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                                            <TableCell sx={uploadDateCell}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                                            <TableCell sx={uploaderCell}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                                            <TableCell sx={iconCell}></TableCell>
                                                            <TableCell sx={iconCell}></TableCell>
                                                            <TableCell sx={iconCell}></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>予測集計表</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {/* S店 5年間推移表 */}
                                                {sStoreTrendsFileList && sStoreTrendsFileList.length > 0 && 
                                                    sStoreTrendsFileList.map((row: any, index: number) => (
                                                        <TableRow key={`s-store-trends-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === sStoreTrendsFileList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.pdf_path, "s-store-trends")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.pdf_path, "s-store-trends")}>{row.upload_date}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.pdf_path, "s-store-trends")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.pdf_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.pdf_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton
                                                                    sx={{ color: "black" }} 
                                                                    onClick={() => {
                                                                        const extension = "." + row.pdf_path.split(".").pop();
                                                                        commonFileDownload(`/${usePlanAreaId}/${objLongPageParam.branch}${row.pdf_path}`, `${row.file_name}${extension}`);
                                                                    }}
                                                                >
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* S店 予測集計表 */}
                                                {sStoreSalesForecastList && sStoreSalesForecastList.length > 0 && 
                                                    sStoreSalesForecastList.map((row: any, index: number) => (
                                                        <TableRow key={`s-store-sales-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === sStoreSalesForecastList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "s-store-sales")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-sales")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-sales")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row, true)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* S店 その他資料RR */}
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>その他資料RR</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {sStoreOtherDocumentRRList && sStoreOtherDocumentRRList.length > 0 && 
                                                    sStoreOtherDocumentRRList.map((row: any, index: number) => (
                                                        <TableRow key={`s-store-other-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === sStoreOtherDocumentRRList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.path, "s-store-other")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.path, "s-store-other")}>{dayjs(row.upload_date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.path, "s-store-other")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton
                                                                    sx={{ color: "black" }}
                                                                    onClick={() => {
                                                                        const extension = "." + row.path.split(".").pop();
                                                                        commonFileDownload(`/${usePlanAreaId}/${objLongPageParam.branch}${row.path}`, `${row.file_name}${extension}`);
                                                                    }}
                                                                >
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* S店 地図 */}
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>地図</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {sStoreMapList && sStoreMapList.length > 0 && 
                                                    sStoreMapList.map((row: any, index: number) => (
                                                        <TableRow key={`s-store-map-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === sStoreMapList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "s-store-map")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-map")}>{row.upload_date}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-map")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row, true)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                                {/* S店 図面 */}
                                                <TableRow sx={{ height: "73px", ...subHeaderRow }}>
                                                    <TableCell sx={narrowSubHeaderCell}>図面</TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                    <TableCell sx={subHeaderCell}></TableCell>
                                                </TableRow>
                                                {sStoreDrawingList && sStoreDrawingList.length > 0 && 
                                                    sStoreDrawingList.map((row: any, index: number) => (
                                                        <TableRow key={`s-store-drawing-${index}`}>
                                                            <TableCell sx={narrowSubHeaderBlankCell(index === sStoreDrawingList.length - 1)}></TableCell>
                                                            <TableCell sx={{ cursor: "pointer" }} onClick={() => handlePreviewChange(row.file_path, "s-store-drawing")}>{row.file_name}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-drawing")}>{row.upload_date}</TableCell>
                                                            <TableCell onClick={() => handlePreviewChange(row.file_path, "s-store-drawing")}>{staffName(row.upload_user_id)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewModalOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => handlePdfPreviewScreenOpen(`/${usePlanAreaId}/${objLongPageParam.branch}${row.file_path}`)}>
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <IconButton sx={{ color: "black" }} onClick={() => fileDownload(row, true)}>
                                                                    <DownloadIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>

                            {/* S店 任意確認資料統一プレビュー */}
                            {previewPdfPathSStoreUnified !== "" && (
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sx={{ margin: "0 20px 20px 20px" }}>
                                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                                            <PdfViewer props={{ pdfPath: previewPdfPathSStoreUnified }} />
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}
                                </>
                            )}
                        </>
                    )}

                </Grid>
            </Grid>
            {/* PDFプレビューモーダル */}
            <PdfViewerModal
                props={{
                    open: pdfPreviewModalFlag,
                    setOpen: setPdfPreviewModalFlag,
                    pdfPath: path,
                }}
            />

        </Box>
    )
};

export default PdfSummary;
